export const variables = {
  fontFamilyBody: ["Open Sans", "sans-serif"].join(","),
  fontFamilyTitle: ["Comfortaa", "cursive"].join(","),
  spacing: 4,
  drawerWidth: 240,
  feedbacksBoxHeight: 800,
  drawerButtonWidth: 68,
  navbarHeight: 72,
};
